<template>
  <div class="table_actions">
    <call-tooltip
      v-for="item in computedConfigItem"
      :key="item.id"
      :disabled="item.disabled"
      :content="item.title">
      <call-button
        outlet
        :type="item.type"
        round
        not-border
        :icon="item.icon"
        @click="clickAction(item.id)" />
    </call-tooltip>

    <popover
      v-if="false"
      v-model="showPopover"
      trigger="click">
      <div class="my-popover">
        <div class="my-popover__title">
          Actions
        </div>

        <div class="my-popover__wrap">
          <div
            v-for="item in computedConfigItem"
            :key="item.id"
            class="my-popover__item"
            :class="[item.disabled && 'my-popover__item--disabled']"
            @click="clickAction(item.id)">
            <font-awesome-icon
              :class="[item.type, item.disabled && 'disabled']"
              :icon="item.icon" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <template #reference>
        <call-button
          class="popover-button"
          outlet
          round
          not-border
          :icon="dataEllipsisIcon" />
      </template>
    </popover>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import {
  faEye,
  faPen,
  faPowerOff,
  faBackward,
  faEllipsis,
  faPlay,
  faStop,
  faPause,
  faHistory
} from '@fortawesome/pro-regular-svg-icons';
import Popover from 'vant/lib/popover';

export default {
  name: 'CallTableAutoCallDetailActions',
  components: { CallButton, Popover },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    blocked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showPopover: false,
      activePopoverId: null,
      dataViewIcon: faEye,
      dataReadingIcon: faPen,
      dataLockIcon: faPowerOff,
      dataUnlockIcon: faBackward,
      dataEllipsisIcon: faEllipsis,
      configItem: [
        {
          id: 'view',
          type: 'success',
          icon: faEye,
          title: 'Info'
        },
        // {
        //   id: 'edit',
        //   type: 'warning',
        //   icon: faPen,
        //   title: 'Edit',
        //   disabled: true
        // },
        {
          id: 'play',
          type: 'success',
          icon: faPlay,
          title: 'Play',
          disabled: false
        },
        {
          id: 'pause',
          type: 'warning',
          icon: faPause,
          title: 'Pause',
          disabled: false
        },
        {
          id: 'stop',
          type: 'danger',
          icon: faStop,
          title: 'Stop',
          disabled: false
        }
        // {
        //   id: 'archive',
        //   type: 'danger',
        //   icon: faHistory,
        //   title: 'Archive',
        //   disabled: false
        // }
      ]
    };
  },

  computed: {
    computedConfigItem () {
      return this.configItem.filter((item) => {
        if ((this.disabled || this.data.item.type !== 'auto') &&
          item.id === 'edit') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_task_pause_allowed &&
          item.id === 'pause') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_task_resume_allowed &&
          item.id === 'play') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_task_stop_allowed &&
          item.id === 'stop') {
          return false;
        }
        return true;
      });
    }
  },

  methods: {
    clickAction (action) {
      this.showPopover = false;
      this.$emit('on-action', action);
    }
  }
};
</script>

<style lang="scss">

  .my-popover {
    display: flex;
    flex-direction: column;
    padding: 8px 8px;
    min-width: 136px;

    margin-left: -16px !important;
    padding-left: 24px;
    // padding-right: 48px;
    &__title {
      padding: 8px;
      font-size: 14px;
      font-family: 'cera-bold', sans-serif;
      color: #222;
    }
    &__wrap {
      display: flex;
      flex-direction: column;
      // gap: 16px;
    }
    &__item {
      font-size: 12px;
      padding: 8px;
      width: 120px;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all .2s;
      &:hover {
        border-radius: 8px;
        background-color: #e8f5ed;
        cursor: pointer;
      }
    }
  }

</style>
